import { render, staticRenderFns } from "./MainSidebar.vue?vue&type=template&id=27036ea1&scoped=true&"
import script from "./MainSidebar.vue?vue&type=script&lang=js&"
export * from "./MainSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MainSidebar.vue?vue&type=style&index=0&id=27036ea1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27036ea1",
  null
  
)

export default component.exports